<template>
  <form class="form-register" @submit.prevent="submit">
    <header class="form-header">
      <h1 class="form-header__title">{{ campaignName }}</h1>
      <h2 class="form-header__subtitle" v-html="subtitle"></h2>
    </header>

    <div class="form-content">
      <div class="row">
        <FormPaymentCard
          v-for="(method, index) in paymentMethods"
          :key="index"
          :item="method"
          @change="selectMethod"
          :selected="paymentMethods.length === 1"
        />
      </div>

      <div class="row align-center">
        <Button type="submit" :disabled="!methodSelected">Confirmar</Button>
      </div>
    </div>
  </form>
</template>

<script>
import FormPaymentCard from './control/FormPaymentCard.vue';
import Button from '../buttons/Button.vue';

export default {
  name: 'FormPayment',
  data() {
    return {
      methodSelected: null,
      campaignName: sessionStorage.campaign,
      physicalCard: sessionStorage.physical_card,
      physicalCardMessage: sessionStorage.physical_card_message,
      installments: sessionStorage.credit_card_installments,
      paymentMethods: [
        {
          id: 1,
          method: 'credit_card',
          slug: 'credit-card',
          type: 'Anuidade',
          description: `ao ano no cartão de crédito`,
          value: sessionStorage.credit_card,
          discountedValue: null
        },
        {
          id: 2,
          method: 'bank_slip',
          slug: 'barcode',
          type: 'Boleto Bancário',
          description: 'à vista',
          value: sessionStorage.bank_slip,
          discountedValue: null
        },
        {
          id: 3,
          method: 'subscription',
          slug: 'calendar-day',
          type: 'Mensalidade',
          description: 'ao mês no cartão de crédito',
          value: sessionStorage.subscription,
          discountedValue:
            sessionStorage.discounted_subscription === 'null'
              ? null
              : sessionStorage.discounted_subscription
        },
        {
          id: 4,
          method: 'pix',
          slug: 'qrcode',
          type: 'Pix',
          description: 'à vista no Pix',
          value: sessionStorage.pix
        }
      ].filter(item => item.value !== 'null')
    };
  },
  components: {
    FormPaymentCard,
    Button
  },
  mounted() {
    this.handleSingleOption();
  },
  methods: {
    handleSingleOption() {
      const validPaymentValues = this.paymentMethods.filter(item => item.value);
      if (validPaymentValues.length === 1) {
        this.selectMethod(validPaymentValues[0]);
      }
    },
    submit() {
      if (this.methodSelected) {
        this.$root.$emit('button-loading', true);
        this.$router.push({
          name: this.methodSelected.method,
          params: {
            userId: this.programId
          }
        });
        sessionStorage.setItem('method', JSON.stringify(this.methodSelected));
      }
    },
    selectMethod(e) {
      this.methodSelected = e;
    }
  },
  computed: {
    subtitle: {
      get() {
        if (this.physicalCard !== 'null' && this.physicalCardMessage === 'true') {
          return `Você será cobrado uma <strong>ÚNICA</strong> vez pelo cartão físico no valor de <strong>R$ ${this.physicalCard}</strong> e conforme abaixo`;
        }

        return 'Escolha uma forma de pagamento abaixo';
      }
    }
  }
};
</script>
